import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type ModalState = Record<string, boolean>;

const initialState: ModalState = {};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModalAction(state, action: PayloadAction<string>) {
      state[action.payload] = true;
    },
    closeModalAction(state, action: PayloadAction<string>) {
      state[action.payload] = false;
    },
  },
});

export const { openModalAction, closeModalAction } = modalSlice.actions;
